import React from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Edit } from '@mui/icons-material'

type PermissionActionMenuProps = {
    anchorEl?: null | HTMLElement
    id?: string
    onClose: () => void
    onEditPermissionAction: (id: string) => void
}

export const PermissionActionMenu: React.FC<PermissionActionMenuProps> = ({
    anchorEl,
    onClose,
    onEditPermissionAction,
    id,
}) => {
    const { t } = useTranslation()

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClose={onClose}
            PaperProps={{ sx: { minWidth: 200 } }}
        >
            <List sx={{ width: '100%' }}>
                <ListItemButton onClick={() => onEditPermissionAction(id!)}>
                    <ListItemIcon>
                        <Edit />
                    </ListItemIcon>
                    <ListItemText primary={t('common.edit')} />
                </ListItemButton>
            </List>
        </Popover>
    )
}
